export const isSurveyActive = (status, returnWhenActive, returnWhenInactive) =>
  status === 'active' ? returnWhenActive : returnWhenInactive



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/survey/index.js